import request from './request'

export function getSalespersonBindList(params = {}) {
  return request({
    url: '/salesperson/bindList',
    method: 'get',
    params: {
      page: 1,
      ...params
    }
  })
}
